import { render } from "./catalogMain.vue?vue&type=template&id=0468758c"
import script from "./catalogMain.vue?vue&type=script&lang=js"
export * from "./catalogMain.vue?vue&type=script&lang=js"
script.render = render

export default script